import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Icon, Image, Richtext } from '../../elements';

import styles from './ProductCard.module.scss';

const ProductCard = (props) => {
    const TagName = props.link ? Link : 'a';

	return (
		<TagName className={styles.wrapper} to={props.link ? props.link : null} onClick={() => props.onClick ? props.onClick() : null}>
			<div className={styles.imageWrapper}>
				<Image src={props.image} placeholder={props.imagePlaceholder} width='485' height='205' />
			</div>

			<div className={styles.footer}>
				<h3 className={styles.title}>{props.productName}</h3>
				<Icon name='arrow-right' size='24' color='#DD0000' />

				{props.description && (
					<Richtext additionalClass={styles.description}>
						<p>{props.description}</p>
					</Richtext>
				)}
			</div>
		</TagName>
	);
};

ProductCard.propTypes = {
	image: PropTypes.string.isRequired,
	imagePlaceholder: PropTypes.string.isRequired,
	productName: PropTypes.string.isRequired,
	link: PropTypes.string,
	description: PropTypes.string,
    onClick: PropTypes.func,
};

export default ProductCard;
